/**
 * NFR1: files at/under this row count interpret with a fast poll (sync-feeling); above it, the
 * BFF always processes asynchronously with an in-portal notification instead. Mirrors
 * `SYNC_ROW_THRESHOLD` in `apps/api/src/modules/intake/interpretation/interpretation.service.ts`
 * — kept as a small local constant since the frontend never imports backend code.
 */
export const SYNC_ROW_THRESHOLD = 300;
